import {
  APP_HEADER_AND_PADDING_HEIGHT_PX,
  NARROW_APP_HEADER_DELTA_PX,
} from '../../../../constants';

// Window height - header height and paddings - grid header height
export const getGridHeightString = (
  isSlaveGrid: boolean,
  gridHeaderHeight: number,
  isNarrowAppHeader: boolean = false
): string => {
  const windowHeight = window.innerHeight;

  // DetailContent.css's 165 bakes in all header/padding height (no header row of its own).
  // SlaveGrid has its own header, subtracted separately via gridHeaderHeight (default 60),
  // so 105 (= 165 - 60) avoids double-subtracting it and keeps both tab panels equal height.
  if (isSlaveGrid && windowHeight >= 820) {
    return `calc(75vh - 105px - ${gridHeaderHeight}px)`;
  }

  if (isSlaveGrid) {
    return '450px';
  }

  const appHeaderAndPaddingHeight = isNarrowAppHeader
    ? APP_HEADER_AND_PADDING_HEIGHT_PX - NARROW_APP_HEADER_DELTA_PX
    : APP_HEADER_AND_PADDING_HEIGHT_PX;

  return `calc(100vh - ${appHeaderAndPaddingHeight}px - ${gridHeaderHeight}px)`;
};
